module.exports = __webpack_public_path__ + "img/433-b25027.png";